var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from "react";
import { classNames } from "@bookingcom/bui-core/utilities/classNames";
import mixinClassNames from "../../utilities/mixinClassNames.js";
import { mixinStyles } from "@bookingcom/bui-core/utilities/styles";
import MinusIcon from "@bookingcom/bui-assets-react/streamline/MinusIcon";
import PlusIcon from "@bookingcom/bui-assets-react/streamline/PlusIcon";
import Button from "../Button/index.js";
import Text from "../Text/index.js";
import useId from "../../hooks/useId.js";
import styles from "@bookingcom/bui-core/css/InputStepper.module.css";
var InputStepperControlled = function (props) {
    var id = props.id, value = props.value, name = props.name, _a = props.size, size = _a === void 0 ? "medium" : _a, label = props.label, helper = props.helper, min = props.min, max = props.max, _b = props.step, step = _b === void 0 ? 1 : _b, disabled = props.disabled, onChange = props.onChange, className = props.className, attributes = props.attributes, mixin = props.mixin;
    var rootClassName = classNames(styles.root, className, mixinClassNames(mixin));
    var rootAttributes = __assign(__assign({}, attributes), { style: __assign(__assign({}, ((attributes === null || attributes === void 0 ? void 0 : attributes.style) || {})), mixinStyles(mixin)) });
    var stepperId = useId(id);
    var getValue = function (value) {
        if (value === null)
            return min || 0;
        var withMin = min ? Math.max(value, min) : value;
        return max ? Math.min(withMin, max) : withMin;
    };
    var change = React.useCallback(function (value) {
        if (value < min || value > max)
            return;
        if (onChange)
            onChange({ name: name, value: value });
    }, [min, max, name, onChange]);
    var handleSubtract = function () { return value !== null && change(value - step); };
    var handleAdd = function () { return value !== null && change(value + step); };
    var handleChange = function (e) {
        return change(+e.target.value);
    };
    var handleKeyDown = function (e) {
        if (e.key === "-")
            handleSubtract();
        if (e.key === "+")
            handleAdd();
    };
    React.useEffect(function () {
        if (value === null) {
            change(min);
            return;
        }
        if (min > value)
            change(min);
    }, [min, value]); // eslint-disable-line react-hooks/exhaustive-deps
    React.useEffect(function () {
        if (!value)
            return;
        if (max < value)
            change(max);
    }, [max, value]); // eslint-disable-line react-hooks/exhaustive-deps
    var normalizedValue = getValue(value);
    /* remove title and subtitle in the following block once deprecated */
    return (React.createElement("div", __assign({}, rootAttributes, { className: rootClassName }),
        React.createElement("input", { type: "range", className: styles.input, id: stepperId, min: min, max: max, step: step, value: normalizedValue, "aria-valuemin": min, "aria-valuemax": max, "aria-valuenow": normalizedValue, onChange: handleChange, onKeyDown: handleKeyDown, disabled: disabled }),
        label && (React.createElement("div", { className: styles["label-wrapper"] },
            React.createElement("label", { className: styles.label, htmlFor: stepperId }, label),
            helper && (React.createElement(Text, { variant: "small_1", color: "neutral_alt", className: styles["helper-text"] }, helper)))),
        React.createElement("div", { className: styles.wrapper },
            React.createElement(Button, { icon: MinusIcon, variant: "tertiary", size: size, disabled: disabled || normalizedValue <= min, className: styles.subtract, attributes: { tabIndex: -1, "aria-hidden": "true" }, onClick: handleSubtract }),
            React.createElement("span", { className: styles.value, "aria-hidden": "true" }, normalizedValue),
            React.createElement(Button, { icon: PlusIcon, variant: "tertiary", size: size, disabled: disabled || normalizedValue >= max, className: styles.add, attributes: { tabIndex: -1, "aria-hidden": "true" }, onClick: handleAdd }))));
};
export default InputStepperControlled;
